<template>
  <div class="fin-time-picker">
    <v-menu ref="menuTimePicker"
            v-model="showPicker"
            :close-on-content-click="false"
            :z-index="9999"
            max-width="290px"
            min-width="290px"
            offset-y
            offset-overflow
            transition="scale-transition"
            top
    >
      <template #activator="{ on, attrs }">
        <v-text-field
          v-model="timeFormatted"
          :error-messages="errorMessages"
          :readonly="isMobile"
          :rules="rules ? [rules.validTime, rules.timeInRange] : []"
          append-icon="mdi-clock-time-four-outline"
          filled
          hint="Format: hh:mm"
          v-bind="attrs"
          v-on="on"
          @click:append="showPicker = true"
          @input="val => userEditedTime(val)"
          @update:error="err => $emit('error', err)"
        />
      </template>

      <v-time-picker v-if="showPicker"
                     v-model="time"
                     :max="maxTime"
                     :min="minTime"
                     :color="$finColors.primaryDark"
                     elevation="0"
                     format="24hr"
                     full-width/>
      <v-spacer />

      <div class="d-flex justify-end align-end mt-0 pa-2 fin-time-picker-menu">
        <v-btn color="primary"
               text
               @click="showPicker = false">
          Abbrechen
        </v-btn>
        <v-btn :color="$finColors.primaryDark"
               dark
               @click="saveTime">
          Übernehmen
        </v-btn>
      </div>
    </v-menu>


    <div v-if="debug">
      <pre>Debug Info</pre>
      <pre v-if="time">time: {{ time }} </pre>
      <pre v-if="value">value: {{ value }} </pre>
    </div>
  </div>
</template>

<script>
import finBrowser from "@/js/finBrowser"

export default {
  name: "FinTimePicker",
  data() {
    return {
      isMobile: finBrowser.IS_MOBILE(),
      showPicker: false,
      time: this.value,
      timeFormatted: this.value,
      rules: {
        validTime: value => {
          return this.validateTime(value)
        },
        timeInRange: value => {
          if (value === null) return true
          if (this.minTime !== undefined) {
            return value >= this.minTime
          }
          if (this.maxTime !== undefined) {
            return value <= this.maxTime
          }
          return true
        }
      }
    }
  },
  props: {
    value: {
      type: String
    },
    minTime: {
      type: String
    },
    maxTime: {
      type: String
    },
    /**
     * Displays debug time information
     */
    debug: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    userEditedTime(val){
      this.time = this.timeFormatted
      this.$emit('input', this.time)
    },
    saveTime() {
      this.$refs.menuTimePicker.save(this.time)
      this.timeFormatted = this.time
      this.$emit('input', this.time)
    },
    validateTime(val) {
      let timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/
      return timeRegex.test(val)
    }
  },
  computed: {
    errorMessages() {
      let message
      if (this.rules.validTime(this.time)) {
        if (this.time === null) message = ''
        if (this.minTime !== undefined && this.maxTime !== undefined) {
          message = this.time < this.minTime || this.time > this.maxTime ? 'Die Uhrzeit muss zwischen ' + this.minTime + ' Uhr und ' + this.maxTime + ' Uhr liegen' : ''
        } else if (this.minTime !== undefined) {
          message = this.time < this.minTime ? 'Die Uhrzeit muss nach ' + this.minTime + ' Uhr liegen' : ''
        } else if (this.maxTime !== undefined) {
          message = this.time > this.maxTime ? 'Die Uhrzeit muss vor ' + this.maxTime + ' Uhr liegen' : ''
        }
        return message
      }
      return 'Ungültige Zeit'
    },
    model: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit("input", newVal)
      }
    }
  },
  watch: {
    value(val) {
      this.timeFormatted = val
    }
  }

}
</script>

<style lang="scss" scoped>
.fin-app .v-card {
  border: 0;
}

.fin-time-picker-menu {
  background-color: #fff !important;
}
</style>
